import { RouteItem } from '@eastcoal/router/types/route'

import { HOUSE_AUCTION_PURCHASE_LIST_PAGE_PATH } from './constants/path'

export const houseAuctionPurchaseListRoute: RouteItem = {
  title: '竞拍（房屋）',
  path: HOUSE_AUCTION_PURCHASE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
